import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DispatchPlannerErrorDialogData {
  title: string;
  message: string;
  envelope?: string;
  responseBody?: string;
  isError?: boolean;
}

@Component({
  selector: 'app-dispatch-planner-error-dialog',
  templateUrl: './dispatch-planner-error-dialog.component.html',
  styleUrls: ['./dispatch-planner-error-dialog.component.css']
})
export class DispatchPlannerErrorDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DispatchPlannerErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DispatchPlannerErrorDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
